<template>
  <p
    class="c-paragraph paragraph"
    v-html="data.content"
  />
</template>

<script>
export default {
  name: 'AppParagraph',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.paragraph {}
</style>
